export default __webpack_public_path__ + "static/media/preface 2.28d48ce9.png";